// 数据相关接口
import request from '@/utils/request'

// 赛事列表
export function gameList(params) {
  return request({
    url: `/auth/match/macthList`,
    method: 'get',
    params
  })
}